import React, { FC, useEffect } from 'react';
import { BaseInfoContent, Form, ShowInput } from '@maxtropy/components';
import { DevicePropertyResponse } from '../../../../api/device';

interface BaseInfoProps {
  data?: DevicePropertyResponse;
}

const BaseInfo: FC<BaseInfoProps> = ({ data }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (data) {
      form.setFieldsValue({
        name: data.name,
        sn: data.sn,
        typeName: data.typeName,
        modelName: data.modelName,
        physicalModelNo: data.physicalModelNo ?? data.modelNo,
      });
    }
  }, [data, form]);

  return (
    <Form form={form}>
      <BaseInfoContent layout="horizontal">
        <Form.Item name="name" label="设备名称">
          <ShowInput />
        </Form.Item>

        <Form.Item name="sn" label="设备S/N码">
          <ShowInput />
        </Form.Item>

        <Form.Item name="typeName" label="所属类目">
          <ShowInput />
        </Form.Item>

        <Form.Item name="physicalModelNo" label="物模型型号">
          <ShowInput />
        </Form.Item>

        <Form.Item name="modelName" label="所属型号">
          <ShowInput />
        </Form.Item>
      </BaseInfoContent>
    </Form>
  );
};

export default BaseInfo;
